export default "__VITE_ASSET__yi_QXNmO__"